import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Routes } from 'constants/route.constants';
import commonMessages from 'common/messages/messages';

const useStyles = makeStyles(() => {
  return {
    privacyPolicyTitle: {
      lineHeight: '1rem',
    },
  };
});

const PolicyLinks: FC = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Box mr={4.5}>
        <Link to={Routes.PRIVACY_POLICY}>
          <Typography color="secondary" className={classes.privacyPolicyTitle}>
            {intl.formatMessage(commonMessages.privacyPolicy)}
          </Typography>
        </Link>
      </Box>
      <Box mr={4.5}>
        <Link to={Routes.COOKIE_POLICY}>
          <Typography color="secondary" className={classes.privacyPolicyTitle}>
            {intl.formatMessage(commonMessages.cookiePolicy)}
          </Typography>
        </Link>
      </Box>
      <Box>
        <Link to={Routes.TERMS_OF_SERVICE}>
          <Typography color="secondary" className={classes.privacyPolicyTitle}>
            {intl.formatMessage(commonMessages.termsOfService)}
          </Typography>
        </Link>
      </Box>
    </>
  );
};

export default PolicyLinks;
